// Package Imports
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

// Core Imports
import PageSkeleton from '@/core/components/page-skeleton'
import RouteError from '@/core/components/route-error'
import { queryClient } from '@/core/lib/query-client'
import { routeHasPermission } from '@/core/utils/auth-utils'

// External Module Imports
import { dashboardRoute } from '@/modules/dashboard/dashboard.routes'

// Module Imports
import { periodSearchSchema } from '@/modules/period/period.schemas'
import {
  periodDetailQueryOptions,
  periodListQueryOptions,
} from '@/modules/period/period.hooks'

export const periodRoute = createRoute({
  path: '/periods',
  getParentRoute: () => dashboardRoute,
  errorComponent: ({ error, reset }) => (
    <RouteError error={error} reset={reset} />
  ),
})

export const periodListRoute = createRoute({
  getParentRoute: () => periodRoute,
  path: '/',
  validateSearch: periodSearchSchema,
  loaderDeps: ({ search }) => ({
    page: search.page ?? 1,
    query: search.query ?? '',
    status: search.status ?? 'ALL',
  }),
  beforeLoad: ({ preload }) =>
    routeHasPermission(
      preload,
      'period.list',
      'Periyotlara erişim izniniz yok.'
    ),
  loader: ({ deps }) =>
    queryClient.ensureQueryData(
      periodListQueryOptions(deps.page, deps.query, deps.status)
    ),
  head: () => ({ meta: [{ title: 'Periyotlar' }] }),
  pendingComponent: () => <PageSkeleton />,
  pendingMs: 100,
  component: lazyRouteComponent(
    () => import('@/modules/period/pages/list-period.page')
  ),
})

export const periodCreateRoute = createRoute({
  getParentRoute: () => periodRoute,
  path: '/new',
  beforeLoad: ({ preload }) =>
    routeHasPermission(
      preload,
      'period.create',
      'Periyot oluşturmak için yetkiniz yok.'
    ),
  head: () => ({ meta: [{ title: 'Yeni Periyot' }] }),
  pendingComponent: () => <PageSkeleton />,
  pendingMs: 100,
  component: lazyRouteComponent(
    () => import('@/modules/period/pages/create-period.page')
  ),
})

export const periodEditRoute = createRoute({
  getParentRoute: () => periodRoute,
  path: '$id/edit',
  beforeLoad: ({ preload }) =>
    routeHasPermission(
      preload,
      'period.update',
      'Periyot düzenlemek için yetkiniz yok.'
    ),
  loader: ({ params }) =>
    queryClient.ensureQueryData(periodDetailQueryOptions(params.id)),
  head: () => ({ meta: [{ title: 'Periyodu Düzenle' }] }),
  pendingComponent: () => <PageSkeleton />,
  pendingMs: 100,
  component: lazyRouteComponent(
    () => import('@/modules/period/pages/edit-period.page')
  ),
})
